import weDOSectionITSol from "data/weDOSectionITSol";
import React, { useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import VisibilitySensor from "react-visibility-sensor";
import TextSplit from "../Reuseable/TextSplit";

const { title, title2, title3, featuredImage, text, barTitle, barPercent, Consultation, Website, Support } = weDOSectionITSol;

const WeDOSectionItSol = () => {
  const [countStart, setCountStart] = useState(false);
  const [consultations, setConsultations] = useState(1);
  const [website, setWebsite] = useState(1);
  const [support, setSupport] = useState(1);


  const onVisibilityChange = (isVisible) => {
    if (isVisible) {
      setCountStart(true);
    }
  };

  return (
    <section className="we-do-section-staff-sol mb-5">
      <div className="auto-container">
        <Row >
          <Col lg={4} md={12} sm={12} className="right-col">
            <div className="inner">
              <div className="sec-title">
                <h5>
                  <TextSplit text={title} />
                  <span className="dot">.</span>
                </h5>
              </div>
              <div className="faq-box">
                <ul className="accordion-box clearfix">
                  {Consultation.map(({ id, title, text }) => (
                    <li
                      key={id}
                      className={`accordion block${
                        consultations === id ? " active-block" : ""
                      }`}
                    >
                      <div
                        onClick={() => setConsultations(id)}
                        className={`acc-btn${
                          consultations === id ? " active" : ""
                        }`}
                      >
                        <span className="count">{id}.</span> {title}
                      </div>
                      <div
                        className={`acc-content animated${
                          consultations === id ? " current slideInUp" : ""
                        }`}
                      >
                        <div className="content">
                          <div className="text">{text}</div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
          <Col lg={4} md={12} sm={12} className="right-col">
            <div className="inner">
              <div className="sec-title">
                <h5>
                  <TextSplit text={title2} />
                  <span className="dot">.</span>
                </h5>
              </div>
              <div className="faq-box">
                <ul className="accordion-box clearfix">
                  {Website.map(({ id, title, text }) => (
                    <li
                      key={id}
                      className={`accordion block${website === id ? " active-block" : ""
                        }`}
                    >
                      <div
                        onClick={() => setWebsite(id)}
                        className={`acc-btn${website === id ? " active" : ""
                          }`}
                      >
                        <span className="count">{id}.</span> {title}
                      </div>
                      <div
                        className={`acc-content animated${website === id ? " current slideInUp" : ""
                          }`}
                      >
                        <div className="content">
                          <div className="text">{text}</div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
          <Col lg={4} md={12} sm={12} className="right-col">
            <div className="inner">
              <div className="sec-title">
                <h5>
                  <TextSplit text={title3} />
                  <span className="dot">.</span>
                </h5>
              </div>
              <div className="faq-box">
                <ul className="accordion-box clearfix">
                  {Support.map(({ id, title, text }) => (
                    <li
                      key={id}
                      className={`accordion block${support === id ? " active-block" : ""
                        }`}
                    >
                      <div
                        onClick={() => setSupport(id)}
                        className={`acc-btn${support === id ? " active" : ""
                          }`}
                      >
                        <span className="count">{id}.</span> {title}
                      </div>
                      <div
                        className={`acc-content animated${support === id ? " current slideInUp" : ""
                          }`}
                      >
                        <div className="content">
                          <div className="text">{text}</div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default WeDOSectionItSol;
